import React from 'react';
import PropTypes from 'prop-types';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

const MetadataButton = ({ metadata, handleChange }) => {
    const classes = ['metadata-button'];
    const label = metadata.count > 0 ? `${metadata.label} (${metadata.count})` : metadata.label;

    if (metadata.isSelected) {
        classes.push('selected is-price');
    }

    return (
        <button className={classes.join(' ')} onClick={() => handleChange(metadata.code)}>
            {label}
        </button>
    );
};

MetadataButton.propTypes = {
    metadata: PropTypes.instanceOf(MetaDataModel).isRequired,
    handleChange: PropTypes.func.isRequired,
};

MetadataButton.displayName = 'MetadataButton';

export default MetadataButton;
